import { render, staticRenderFns } from "./VMessageControl.vue?vue&type=template&id=d9bff12a&scoped=true&"
import script from "./VMessageControl.vue?vue&type=script&lang=ts&"
export * from "./VMessageControl.vue?vue&type=script&lang=ts&"
import style0 from "./VMessageControl.vue?vue&type=style&index=0&id=d9bff12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bff12a",
  null
  
)

export default component.exports